// Tiny global bus so any page can trigger an immediate notification-count
// refresh in NotificationsBell without prop-drilling or coupling.
//
// Usage: import { pingNotifications } from '../lib/notificationsBus';
//        pingNotifications();
export const pingNotifications = () => {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new Event('civilx:notifications-refresh'));
  } catch (_) { /* non-fatal */ }
};
